import { Injectable } from '@angular/core';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class ImageUrlService {
  url = environment.endpoint.assets;

  getImageUrl(image: string): string {
    return `${this.url}/${image}`;
  }
}
